module.exports = __webpack_public_path__ + "static/media/01_IPhone_BaerbelWagner_webfinal.993a3920.jpg";